export default __webpack_public_path__ + "static/media/bathiya.b856786d.jpg";